import React from 'react';

const OrderCard = ({ order, onMove }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'new': return 'border-orange-500 shadow-[0_0_15px_rgba(249,115,22,0.4)]';
      case 'preparing': return 'border-yellow-400 shadow-[0_0_15px_rgba(250,204,21,0.4)]';
      case 'ready': return 'border-green-500 shadow-[0_0_15px_rgba(34,197,94,0.4)]';
      default: return 'border-gray-500';
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'new': return <span className="bg-orange-500 text-white text-xs px-2 py-1 rounded-full font-bold">NUEVO 🔔</span>;
      case 'preparing': return <span className="bg-yellow-500 text-white text-xs px-2 py-1 rounded-full font-bold">EN COCINA 🍳</span>;
      case 'ready': return <span className="bg-green-500 text-white text-xs px-2 py-1 rounded-full font-bold">LISTO 🚀</span>;
      default: return null;
    }
  };

  return (
    <div className={`order-card bg-[#1e293b] bg-opacity-80 backdrop-blur-md border-l-4 rounded-lg p-4 mb-4 text-white transition-all duration-300 hover:scale-[1.02] ${getStatusColor(order.status)}`}>
      
      <div className="flex justify-between items-start mb-3">
        <h3 className="text-xl font-bold font-mono">#{order.id}</h3>
        {getStatusBadge(order.status)}
      </div>

      <div className="mb-4 text-sm text-gray-300">
        <p className="flex items-center gap-2 mb-1">
          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
          Hace {order.timeElapsed} min
        </p>
        <p className="flex items-center gap-2 font-medium">
          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
          {order.customerName}
        </p>
      </div>

      <div className="bg-[#0f172a] rounded p-3 mb-4">
        <ul className="list-disc list-inside space-y-1">
          {(order.items || []).map((item, idx) => (
            <li key={idx} className="text-sm font-medium">{item}</li>
          ))}
        </ul>
        {order.notes && (
          <p className="text-xs text-yellow-400 mt-2 italic flex items-start gap-1">
            <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
            {order.notes}
          </p>
        )}
      </div>

      <div className="flex gap-2 mt-auto">
        {order.status === 'new' && (
          <button 
            onClick={() => onMove(order.id, 'preparing')}
            className="flex-1 bg-yellow-500 hover:bg-yellow-400 text-black font-bold py-2 rounded transition-colors"
          >
            A Cocina 🍳
          </button>
        )}
        {order.status === 'preparing' && (
          <button 
            onClick={() => onMove(order.id, 'ready')}
            className="flex-1 bg-green-600 hover:bg-green-500 text-white font-bold py-2 rounded transition-colors"
          >
            Marcar Listo ✅
          </button>
        )}
        {order.status === 'ready' && (
          <button 
            onClick={() => onMove(order.id, 'delivered')}
            className="flex-1 bg-blue-600 hover:bg-blue-500 text-white font-bold py-2 rounded transition-colors"
          >
            Despachar 🛵
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderCard;
